import { render, staticRenderFns } from "./uf_scalable_product_project.vue?vue&type=template&id=6ef87cb2&scoped=true"
import script from "./uf_scalable_product_project.vue?vue&type=script&lang=js"
export * from "./uf_scalable_product_project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef87cb2",
  null
  
)

export default component.exports